import React, { useCallback, useEffect, useState } from "react";
import styles from "../styles/storagesView.module.css";
import CreateStorageModal from "./tables/customComponentsTable/CreateStorageModal";
import { FiTrash2 } from "react-icons/fi";
import { API_URL } from "../config/api";

const StoragesView = () => {
  const [storages, setStorages] = useState([]);
  const [regions, setRegions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedStorage, setSelectedStorage] = useState(null);

  const token = localStorage.getItem("token");

  // ================= GET STORAGES =================
  const fetchStorages = useCallback(async () => {
    try {
      console.log("📡 GET /storages");
      const res = await fetch(`${API_URL}/api/storages`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("GET status:", res.status);
      const data = await res.json();
      console.log("GET response:", data);

      if (Array.isArray(data.data)) {
        setStorages(data.data);
        localStorage.setItem("storages", JSON.stringify(data.data));
      } else {
        throw new Error("Ожидался массив складов");
      }
    } catch (err) {
      console.error("❌ Ошибка загрузки складов:", err);
      const saved = localStorage.getItem("storages");
      if (saved) setStorages(JSON.parse(saved));
    }
  }, [token]);

  // ================= GET REGIONS =================
  const fetchRegions = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/regions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (Array.isArray(data.data)) setRegions(data.data);
    } catch (err) {
      console.error("❌ Ошибка загрузки регионов:", err);
    }
  }, [token]);

  useEffect(() => {
    if (!token) {
      console.error("❌ Нет токена");
      return;
    }
    fetchStorages();
    fetchRegions();
  }, [token, fetchRegions, fetchStorages]);

  const getRegionName = (regionId) => {
    const region = regions.find((r) => r.id === regionId);
    return region ? region.name_ru : "—";
  };

  // ================= OPEN EDIT =================
  const openEditModal = (storage) => {
    setSelectedStorage(storage);
    setShowModal(true);
  };

  // ================= TOGGLE STATUS =================
  const toggleStatus = async (storage) => {
    const newStatus = storage.status === "active" ? "disabled" : "active";

    try {
      const res = await fetch(`${API_URL}/api/storages/${storage.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (!res.ok) throw new Error();

      setStorages((prev) => {
        const updated = prev.map((s) =>
          s.id === storage.id ? { ...s, status: newStatus } : s
        );
        localStorage.setItem("storages", JSON.stringify(updated));
        return updated;
      });
    } catch {
      alert("Ошибка изменения статуса");
    }
  };

  // ================= DELETE =================
  const deleteStorage = async (id) => {
    if (!window.confirm("Удалить склад?")) return;

    try {
      const res = await fetch(`${API_URL}/api/storages/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error();

      setStorages((prev) => {
        const updated = prev.filter((s) => s.id !== id);
        localStorage.setItem("storages", JSON.stringify(updated));
        return updated;
      });
    } catch {
      alert("Ошибка удаления");
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.headerText}>Склады</h2>

      <button
        className={styles.addCustomers}
        onClick={() => {
          setSelectedStorage(null);
          setShowModal(true);
        }}
      >
        +
      </button>

      <CreateStorageModal
        isOpen={showModal}
        storage={selectedStorage}
        onClose={() => {
          setShowModal(false);
          setSelectedStorage(null);
        }}
        onCreated={fetchStorages}
      />

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Название</th>
            <th>Регион</th>
            <th>Налог</th>
            <th>Статус</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {storages.map((storage) => (
            <tr
              key={storage.id}
              className={styles.row}
              onClick={() => openEditModal(storage)}
            >
              <td>{storage.name}</td>
              <td>{getRegionName(storage.region_id)}</td>
              <td>—</td>

              <td>
                <label className={styles.toggle}>
                  <input
                    type="checkbox"
                    checked={storage.status === "active"}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => toggleStatus(storage)}
                  />
                  <span className={styles.slider}></span>
                </label>
              </td>

              <td>
                <button
                  className={styles.deleteButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteStorage(storage.id);
                  }}
                >
                  <FiTrash2 size={18} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StoragesView;
